import { TCreateConverter, TFetchConverter } from '../types/converter.types';
import {
  TScimConfigurationDB,
  TScimConfigurationDeterminePositionBasedOnGroupDB,
  TScimConfigurationDeterminePositionBasedOnGroupUI,
  TScimConfigurationEnabledDB,
  TScimConfigurationEnabledUI,
  TScimConfigurationUI,
  TScimGroupDB,
  TScimGroupIncludeFuturePropertiesDB,
  TScimGroupIncludeFuturePropertiesUI,
  TScimGroupPositionDB,
  TScimGroupPositionUI,
  TScimGroupPropertyMappingsDB,
  TScimGroupPropertyMappingsUI,
  TScimGroupsPageDB,
  TScimGroupsPageUI,
  TScimGroupUI,
} from '../types/scim.types';

export const scimConfigurationConverter: TFetchConverter<TScimConfigurationUI, TScimConfigurationDB> = {
  fromDb: (data) => ({
    token: data.token,
    enabled: data.enabled ?? true,
    determinePositionBasedOnGroup: data.determinePositionBasedOnGroup ?? false,
  }),
};

export const scimGroupConverter: TFetchConverter<TScimGroupUI, TScimGroupDB> = {
  fromDb: (data) => ({
    id: data.id,
    name: data.name,
    position: data.position ?? null,
    properties: (data.properties || []).map((property) => ({
      id: property.id,
      name: property.name,
    })),
    teamMemberCount: data.teamMemberCount,
    includeFutureProperties: data.includeFutureProperties,
    assignedPropertyManagers: (data.assignedPropertyManagers || []).map((propertyManager) => ({
      id: propertyManager.id,
      name: propertyManager.name,
      email: propertyManager.email,
    })),
  }),
};

export const scimGroupsPageConverter: TFetchConverter<TScimGroupsPageUI, TScimGroupsPageDB | null> = {
  fromDb: (data) => ({
    content: (data?.content || []).map(scimGroupConverter.fromDb),
    paginationData: {
      totalElements: data?.totalElements,
      totalPages: data?.totalPages,
      number: data?.number,
      size: data?.size,
    },
  }),
};

export const scimGroupPropertyMappingsConverter: TCreateConverter<
  TScimGroupPropertyMappingsUI,
  TScimGroupPropertyMappingsDB
> = {
  toDb: (data) => ({
    scimGroupId: data.scimGroupId,
    propertyIds: data.propertyIds,
  }),
};

export const scimGroupIncludeFuturePropertiesConverter: TCreateConverter<
  TScimGroupIncludeFuturePropertiesUI,
  TScimGroupIncludeFuturePropertiesDB
> = {
  toDb: (data) => ({
    scimGroupId: data.scimGroupId,
    includeFutureProperties: data.includeFutureProperties,
  }),
};

export const scimConfigurationEnabledConverter: TCreateConverter<
  TScimConfigurationEnabledUI,
  TScimConfigurationEnabledDB
> = {
  toDb: (data) => ({
    propertyManagementId: data.propertyManagementId,
    enabled: data.enabled,
  }),
};

export const scimConfigurationDeterminePositionBasedOnGroupConverter: TCreateConverter<
  TScimConfigurationDeterminePositionBasedOnGroupUI,
  TScimConfigurationDeterminePositionBasedOnGroupDB
> = {
  toDb: (data) => ({
    propertyManagementId: data.propertyManagementId,
    determinePositionBasedOnGroup: data.determinePositionBasedOnGroup,
  }),
};

export const scimGroupPositionConverter: TCreateConverter<TScimGroupPositionUI, TScimGroupPositionDB> = {
  toDb: (data) => ({
    scimGroupId: data.scimGroupId,
    position: data.position,
  }),
};
